<template>
  <v-container fluid>
    <v-card tile class="mt-2">
      <a-table size="small" bordered :columns="headers" :data-source="list" :pagination="false"
        :locale="{ emptyText: '暂无数据' }" row-key="_id">
        <template slot="title">
          <div class="d-flex justify-space-between">
            <a-space class="pl-2">
              <v-btn tile small class="primary white--text" @click="getdata()">
                <v-icon small>mdi-refresh</v-icon>刷新
              </v-btn>
              <v-checkbox v-model="show_all" label="显示所有账号" dense hide-details @change="getdata()"></v-checkbox>
            </a-space>
            <v-btn tile small class="success white--text" @click="showadd()">
              <v-icon small>mdi-plus</v-icon>添加
            </v-btn>
          </div>
        </template>
        <template slot="index" slot-scope="text, record, index">
          {{ index + 1 }}
        </template>
        <template slot="state" slot-scope="text, record">
          <a-tag :color="record.state === 1 ? 'green' : 'red'">{{ record.state === 1 ? '在线' : '离线' }}</a-tag>
          <p>{{ record.utime }}</p>
        </template>
        <template slot="notify" slot-scope="text, record">
          <a-switch v-model="record.notify" @change="update(record._id, 'notify', record.notify)"></a-switch>
          <a-tag :color="record.notify === true ? 'green' : 'red'">{{ record.notify === true ? '开启' : '关闭' }}</a-tag>
        </template>
        <template slot="action" slot-scope="text, record">
          <a-space>
            <v-btn text tile color="success" @click="showedit(record)"> 编辑 </v-btn>
            <a-popconfirm title="删除抓取账号" ok-text="确定" cancel-text="取消" @confirm="remove(record._id)">
              <v-btn text tile color="error"> 删除 </v-btn>
            </a-popconfirm>
          </a-space>
        </template>
      </a-table>
    </v-card>
    <v-dialog v-model="model" width="400">
      <a-card title="车管平台账号">
        <a-space slot="extra">
          <a-checkbox v-model="continue_add">连续添加</a-checkbox>
          <a-button type="danger" :loading="saving" :disabled="saving" @click="save"> 提交保存
          </a-button>
          <a-button @click="model = false"> 取消
          </a-button>
        </a-space>
        <a-form-model ref="formRef" :model="form" layout="vertical">
          <a-row :gutter="16">
            <a-col :span="24">
              <a-form-model-item label="邮局" prop="postoffice">
                <a-input v-model="form.postoffice" placeholder="邮局" :disabled="saving" allow-clear>
                </a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="24">
              <a-form-model-item label="账号" prop="login_id">
                <a-input v-model="form.login_id" placeholder="账号" :disabled="saving" allow-clear>
                </a-input>
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
      </a-card>
    </v-dialog>
  </v-container>
</template>

<script>
import _ from "underscore";
import { mapState } from "vuex";
export default {
  name: "RoadBill",
  data() {
    return {
      show_all: false,
      form: {},
      saving: false,
      list: [],
      headers: [
        { title: "序号", dataIndex: "index", scopedSlots: { customRender: "index" }, width: 80, align: "center" },
        { title: "邮局", dataIndex: "postoffice", scopedSlots: { customRender: "postoffice" }, width: 150, align: "center" },
        { title: "账号", dataIndex: "login_id", scopedSlots: { customRender: "login_id" }, width: 150, align: "center" },
        { title: "状态", dataIndex: "state", scopedSlots: { customRender: "state" }, width: 120, align: "center" },
        { title: "通知", dataIndex: "notify", scopedSlots: { customRender: "notify" }, width: 120, align: "center" },
        { title: "操作", dataIndex: "action", scopedSlots: { customRender: "action" }, width: 200, align: "center" },
      ],
      height: 600,
      model: false,
      continue_add: false,
    };
  },
  computed: {
    ...mapState(["role", "username"]),
  },
  components: {},
  watch: {
  },
  mounted() {
  },
  activated() {
    this.list = [];
    this.getdata();
  },
  methods: {
    getdata() {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/cptmcp/accounts", { show_all: this.show_all }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.list = res.data.list;
        } else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    showadd() {
      this.form = {
        _id: "",
        postoffice: "",
        login_id: "",
      };
      this.model = true;
    },
    showedit(item) {
      this.form = {
        _id: item._id,
        postoffice: item.postoffice,
        login_id: item.login_id,
      };
      this.model = true;
    },
    save() {
      this.$toast.loading({ message: "" });
      this.saving = true;
      this.$api.doAPI("/cptmcp/saveaccount", { form: this.form }).then((res) => {
        this.$toast.clear();
        // console.log(res);
        this.saving = false;
        if (res.code === 0) {
          this.model = this.continue_add;
          this.getdata();
        } else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.saving = false;
        this.$toast.clear();
        console.error(err);
      });
    },
    update(_id, key, value) {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/cptmcp/updateaccount", { _id, key, value }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.getdata();
        } else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    remove(_id) {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/cptmcp/removeaccount", { _id }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.getdata();
        } else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
  },
};
</script>
<style lang="less" scoped>
/deep/ .ant-form-item {
  margin-bottom: unset;
}

/deep/ .ant-table-fixed-header .ant-table-scroll .ant-table-header {
  padding-bottom: 4px;
}

p {
  margin: 0;
}
</style>
